import React from "react";
import Game from './Game.js';

function App() { 
  return (
    <div>
      <Game />
    </div>
  );
};

export default App;